import { JsonObject, JsonProperty } from 'json2typescript';
import { TournamentReward } from './tournament-reward.model';

@JsonObject('Tournament')
export class Tournament {

  @JsonProperty('tournament_id', Number)
  tournamentId: number = 0;

  @JsonProperty('type', Number)
  type: number = 0;

  @JsonProperty('start_date_timestamp', Number)
  startDateTimestamp: number = 0;

  @JsonProperty('end_date_timestamp', Number)
  endDateTimestamp: number = 0;

  @JsonProperty('cost_quantity', Number)
  costQuantity: number = 0;

  @JsonProperty('reward_total_quantity', Number)
  rewardTotalQuantity: number = 0;

  @JsonProperty('users_count', Number)
  usersCount: number = 0;

  @JsonProperty('rewards', [TournamentReward])
  rewards: TournamentReward[] = [];
}
